import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import AdvisorNavbar from "../layout/AdvisorNavbar";
import LocContext from "../context/locContext";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import {
  FiXCircle,
  FiGrid,
  FiList,
  FiEye,
  FiRefreshCw,
  FiCalendar,
  FiFilter,
  FiAlertCircle,
} from "react-icons/fi";
import Swal from "sweetalert2";

const ORDER_TYPES = [
  { value: "", label: "All types" },
  { value: "lumpsum", label: "Lumpsum" },
  { value: "sip", label: "SIP" },
  { value: "mandate", label: "Mandate" },
  { value: "bank_payment", label: "Bank payment" },
];

function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export default function FailedOrders() {
  const { userData } = useContext(LocContext);
  const navigate = useNavigate();
  const agentId = userData?.id ?? userData?.user_id;

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState("grid");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [orderType, setOrderType] = useState("");
  const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 20, totalPages: 0 });

  const fetchFailedOrders = async (page = 1) => {
    if (!agentId) {
      setLoading(false);
      setOrders([]);
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/agent/dashboard/failed-orders`,
        {
          params: {
            agent_id: Number(agentId),
            page,
            limit: 20,
            date_from: dateFrom || undefined,
            date_to: dateTo || undefined,
            order_type: orderType || undefined,
          },
        }
      );
      const raw = res.data;
      if (raw && raw.status === 1) {
        const data = Array.isArray(raw.data) ? raw.data : [];
        setOrders(data);
        const pag = raw.pagination || {};
        setPagination({
          total: pag.total ?? 0,
          page: pag.page ?? 1,
          limit: pag.limit ?? 20,
          totalPages: pag.totalPages ?? 0,
        });
      } else {
        setOrders([]);
        setPagination({ total: 0, page: 1, limit: 20, totalPages: 0 });
      }
    } catch (error) {
      console.error("Error fetching failed orders:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to load failed orders",
        timer: 3000,
      });
      setOrders([]);
      setPagination({ total: 0, page: 1, limit: 20, totalPages: 0 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFailedOrders(1);
  }, [agentId]);

  useEffect(() => {
    if (agentId) fetchFailedOrders(1);
  }, [dateFrom, dateTo, orderType]);

  const handleApplyFilters = (e) => {
    e?.preventDefault();
    fetchFailedOrders(1);
  };

  const handleRetry = (order) => {
    Swal.fire({
      icon: "info",
      title: "Retry order",
      text: `Retry for order "${order.order_id || order.id}" will be implemented with your order service.`,
      timer: 2500,
    });
  };

  const handleViewDetails = (order) => {
    navigate(`/agent/mutual-funds/draft-orders?order=${order.order_id || order.id}`);
  };

  return (
    <>
    <AdvisorNavbar />
    <div className="page-content" style={{ background: "#f1f5f9" }}>

          {/* Header */}
          <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px", border: "none" }}>
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div>
                <h2 className="mb-1">
                  Failed Orders
                </h2>
             
              </div>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0 mt-2">
                <li className="breadcrumb-item">
                  <NavLink to="/agent/dashboard" style={{ color: "#1bafb4", textDecoration: "none" }}>
                    Dashboard
                  </NavLink>
                  {" / "}
                </li>
                <li className="breadcrumb-item active" aria-current="page" style={{ color: "#64748b" }}>
                  Failed Orders
                </li>
              </ol>
            </nav>
            <p className="mt-2" style={{ color: "#64748b", fontSize: "14px" }}>
                  Orders that failed for your clients — bank, MF, or mandate
                </p>
          </div>

          {/* Filters */}
          <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px", border: "none" }}>
            <form onSubmit={handleApplyFilters}>
              <div className="row g-3 align-items-end">
                <div className="col-12 col-md-3">
                  <label className="form-label small mb-1" style={{ color: "#64748b", fontWeight: "500" }}>
                    From date
                  </label>
                  <div className="position-relative">
                    <FiCalendar style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "#64748b", fontSize: "16px" }} />
                    <input
                      type="date"
                      className="form-control"
                      value={dateFrom}
                      onChange={(e) => setDateFrom(e.target.value)}
                      style={{ paddingLeft: "36px", borderRadius: "8px", border: "1px solid #e2e8f0" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label small mb-1" style={{ color: "#64748b", fontWeight: "500" }}>
                    To date
                  </label>
                  <div className="position-relative">
                    <FiCalendar style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "#64748b", fontSize: "16px" }} />
                    <input
                      type="date"
                      className="form-control"
                      value={dateTo}
                      onChange={(e) => setDateTo(e.target.value)}
                      style={{ paddingLeft: "36px", borderRadius: "8px", border: "1px solid #e2e8f0" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label small mb-1" style={{ color: "#64748b", fontWeight: "500" }}>
                    Order type
                  </label>
                  <select
                    className="form-select"
                    value={orderType}
                    onChange={(e) => setOrderType(e.target.value)}
                    style={{ borderRadius: "8px", border: "1px solid #e2e8f0" }}
                  >
                    {ORDER_TYPES.map((opt) => (
                      <option key={opt.value || "all"} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12 col-md-3 d-flex align-items-center gap-2">
                  <button
                    type="submit"
                    className="btn d-flex align-items-center gap-2"
                    style={{
                      background: "#1bafb4",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 16px",
                      fontWeight: "500",
                    }}
                  >
                    <FiFilter size={16} />
                    Apply
                  </button>
                  <span style={{ color: "#64748b", fontSize: "14px" }}>
                    Total: {loading ? "..." : pagination.total} failed
                  </span>
                </div>
              </div>
            </form>
          </div>

          {/* View toggle + content */}
          <div className="d-flex justify-content-end mb-3">
            <div className="d-flex gap-1">
              <button
                type="button"
                title="Grid view"
                onClick={() => setViewMode("grid")}
                className="btn btn-sm"
                style={{
                  borderRadius: "8px",
                  border: viewMode === "grid" ? "2px solid #1bafb4" : "1px solid #e2e8f0",
                  background: viewMode === "grid" ? "rgba(27, 175, 180, 0.08)" : "#fff",
                  color: viewMode === "grid" ? "#1bafb4" : "#64748b",
                }}
              >
                <FiGrid size={18} />
              </button>
              <button
                type="button"
                title="List view"
                onClick={() => setViewMode("list")}
                className="btn btn-sm"
                style={{
                  borderRadius: "8px",
                  border: viewMode === "list" ? "2px solid #1bafb4" : "1px solid #e2e8f0",
                  background: viewMode === "list" ? "rgba(27, 175, 180, 0.08)" : "#fff",
                  color: viewMode === "list" ? "#1bafb4" : "#64748b",
                }}
              >
                <FiList size={18} />
              </button>
            </div>
          </div>

          {loading ? (
            <div className="card shadow-sm p-5 text-center" style={{ borderRadius: "12px", border: "none" }}>
              <p style={{ color: "#64748b", margin: 0 }}>Loading failed orders...</p>
            </div>
          ) : viewMode === "list" ? (
            /* List view */
            <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead style={{ background: "#f8fafc", color: "#64748b", fontSize: "13px", fontWeight: "600" }}>
                    <tr>
                      <th style={{ padding: "14px 16px", borderBottom: "2px solid #e2e8f0" }}>Client</th>
                      <th style={{ padding: "14px 16px", borderBottom: "2px solid #e2e8f0" }}>Order type</th>
                      <th style={{ padding: "14px 16px", borderBottom: "2px solid #e2e8f0" }}>Scheme</th>
                      <th style={{ padding: "14px 16px", borderBottom: "2px solid #e2e8f0" }}>Failure reason</th>
                      <th style={{ padding: "14px 16px", borderBottom: "2px solid #e2e8f0" }}>Failed date</th>
                      <th style={{ padding: "14px 16px", borderBottom: "2px solid #e2e8f0", textAlign: "right" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((order) => (
                      <tr
                        key={order.id || order.order_id}
                        style={{ borderLeft: "3px solid #ef4444", cursor: "default" }}
                      >
                        <td style={{ padding: "14px 16px", color: "#1e293b", fontWeight: "500" }}>
                          {order.client_name || order.clientName || "—"}
                        </td>
                        <td style={{ padding: "14px 16px" }}>
                          <span
                            className="badge"
                            style={{
                              background: "#fef2f2",
                              color: "#b91c1c",
                              padding: "6px 10px",
                              borderRadius: "6px",
                              fontSize: "12px",
                              fontWeight: "500",
                            }}
                          >
                            {order.order_type || order.orderType || "—"}
                          </span>
                        </td>
                        <td style={{ padding: "14px 16px", color: "#64748b" }}>
                          {order.scheme_name || order.schemeName || "—"}
                        </td>
                        <td style={{ padding: "14px 16px" }}>
                          <span style={{ color: "#b91c1c", fontSize: "13px" }}>
                            {order.failure_reason || order.failureReason || order.reason || "—"}
                          </span>
                        </td>
                        <td style={{ padding: "14px 16px", color: "#64748b", fontSize: "14px" }}>
                          {formatDate(order.failed_date || order.failedDate || order.created_at)}
                        </td>
                        <td style={{ padding: "14px 16px", textAlign: "right" }}>
                          <button
                            type="button"
                            className="btn btn-sm me-1"
                            style={{
                              background: "rgba(27, 175, 180, 0.1)",
                              color: "#1bafb4",
                              border: "none",
                              borderRadius: "6px",
                              padding: "6px 12px",
                              fontSize: "12px",
                            }}
                            onClick={() => handleViewDetails(order)}
                          >
                            <FiEye size={14} className="me-1" />
                            View
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm"
                            style={{
                              background: "#fef2f2",
                              color: "#b91c1c",
                              border: "1px solid #fecaca",
                              borderRadius: "6px",
                              padding: "6px 12px",
                              fontSize: "12px",
                            }}
                            onClick={() => handleRetry(order)}
                          >
                            <FiRefreshCw size={14} className="me-1" />
                            Retry
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            /* Grid view */
            <div className="row g-3">
              {orders.map((order) => (
                <div key={order.id || order.order_id} className="col-12 col-md-6 col-lg-4">
                  <div
                    className="card h-100 shadow-sm"
                    style={{
                      borderRadius: "12px",
                      border: "none",
                      borderLeft: "4px solid #ef4444",
                      overflow: "hidden",
                      transition: "box-shadow 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = "0 8px 24px rgba(239, 68, 68, 0.12)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div
                          style={{
                            width: "44px",
                            height: "44px",
                            borderRadius: "10px",
                            background: "#fef2f2",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <FiXCircle style={{ fontSize: "22px", color: "#ef4444" }} />
                        </div>
                        <span
                          className="badge"
                          style={{
                            background: "#fef2f2",
                            color: "#b91c1c",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            fontSize: "11px",
                            fontWeight: "600",
                          }}
                        >
                          Failed
                        </span>
                      </div>
                      <h6 className="mb-2" style={{ color: "#1e293b", fontWeight: "600", fontSize: "15px" }}>
                        {order.client_name || order.clientName || "—"}
                      </h6>
                      <div className="mb-2" style={{ fontSize: "13px", color: "#64748b" }}>
                        <span style={{ fontWeight: "500", color: "#475569" }}>Type:</span>{" "}
                        {order.order_type || order.orderType || "—"}
                      </div>
                      <div className="mb-2" style={{ fontSize: "13px", color: "#64748b" }}>
                        <span style={{ fontWeight: "500", color: "#475569" }}>Scheme:</span>{" "}
                        {order.scheme_name || order.schemeName || "—"}
                      </div>
                      <div className="mb-3" style={{ fontSize: "13px" }}>
                        <span style={{ fontWeight: "500", color: "#475569" }}>Reason:</span>{" "}
                        <span style={{ color: "#b91c1c" }}>
                          {order.failure_reason || order.failureReason || order.reason || "—"}
                        </span>
                      </div>
                      <div className="mb-3" style={{ fontSize: "12px", color: "#64748b" }}>
                        {formatDate(order.failed_date || order.failedDate || order.created_at)}
                      </div>
                      <div className="d-flex gap-2 pt-2" style={{ borderTop: "1px solid #e2e8f0" }}>
                        <button
                          type="button"
                          className="btn btn-sm flex-grow-1"
                          style={{
                            background: "rgba(27, 175, 180, 0.1)",
                            color: "#1bafb4",
                            border: "none",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            fontSize: "12px",
                            fontWeight: "500",
                          }}
                          onClick={() => handleViewDetails(order)}
                        >
                          <FiEye size={14} className="me-1" />
                          View Details
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm"
                          style={{
                            background: "#fef2f2",
                            color: "#b91c1c",
                            border: "1px solid #fecaca",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            fontSize: "12px",
                            fontWeight: "500",
                          }}
                          onClick={() => handleRetry(order)}
                        >
                          <FiRefreshCw size={14} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {!loading && orders.length === 0 && (
            <div className="card shadow-sm p-5 text-center" style={{ borderRadius: "12px", border: "none" }}>
              <FiAlertCircle style={{ fontSize: "48px", color: "#94a3b8", marginBottom: "12px" }} />
              <h6 style={{ color: "#475569", fontWeight: "600", marginBottom: "8px" }}>No failed orders</h6>
              <p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>
                Failed orders for your clients will appear here (bank, MF, or mandate failures).
              </p>
            </div>
          )}
        </div>
    </>
    );
}
